import { type FC, type PropsWithChildren } from "react";
import ContainerProvider from "./container-provider";

const ServiceProvider: FC<PropsWithChildren> = ({ children }) => (
  <ContainerProvider>{children}</ContainerProvider>
);

export default ServiceProvider;
